import { createSlice } from '@reduxjs/toolkit';
import  type { AuthState } from '../data/interfaces/itsomodels';


// Define the initial state using that type
const initialState: AuthState = {
    AuthApiReady:false,
    IsAuthenticated:false
}
export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    updateauthapi: (state,action) => {
      state.AuthApiReady=action.payload;
    },
    updateauthentocated:(state,action)=>{
        state.IsAuthenticated=action.payload
    }
  },
});

export const { updateauthapi,updateauthentocated } = authSlice.actions

export default authSlice.reducer